import predefinedModels from "./global-models.json";
import { patchArray } from "../utils/data-utils"

const models = [

];

export default patchArray(predefinedModels, models);
